import React from "react";

// Reusable pulse blocks
export const PulseBox = ({width = '100%', height, borderRadius = 8, style = {}}) => (
    <div className="bg-gray-200 animate-pulse" style={{width, height, borderRadius, flexShrink: 0, ...style}}/>
)

export const PulseLine = ({width = '100%', height = 13, style = {}}) => (
    <div className="bg-gray-200 animate-pulse rounded" style={{width, height, ...style}}/>
)

export const PulseCircle = ({size = 40}) => (
    <div className="bg-gray-200 animate-pulse flex-shrink-0" style={{width: size, height: size, borderRadius: '50%'}}/>
)

